module.exports = __webpack_public_path__ + "img/sold.2ae8c341.gif";